module.exports = "<div class=\"row wrapper border-bottom white-bg page-heading personal-account-header\">\r\n    <div class=\"col-lg-12\">\r\n        <h2>{{title}}</h2>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"personal-account-page help-placeholder-page\">\r\n    <p class=\"help-placeholder-message\">Content coming soon.</p>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/account.management/help/help.placeholder.component.html
// module id = 1520
// module chunks = 0